<template>
    <!-- Clean table component with pagination -->
    <paginated-table
        :pagination="pagination"
        :current-page-data="currentPageData"
        :quick-search-value="quickSearchValue"
        :loading-message="loadingMessage"
        @page-size-change="onPageSizeChange"
        @page-select="onPageSelect"
        @next-page="onNextPage"
        @previous-page="onPreviousPage"
    >
        <template #table="{ filteredData }">
            <v-table>
                <thead>
                    <tr>
                        <th class="text-left" v-for="header in headers" :key="header.value">
                            {{ header.text }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredData" :key="item[primaryKey]">
                        <td v-for="header in headers" :key="header.value">
                            <template v-if="header.value !== actionHeaderValue">
                                {{ formatCellValue(item, header) }}
                            </template>
                            <template v-else>
                                <!-- Customizable table actions slot -->
                                <slot name="table-actions" :item="item" :isLoading="isLoading">
                                    <!-- Default: no actions -->
                                </slot>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </template>
    </paginated-table>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import PaginatedTable from './PaginatedTable.vue';
import { TableFormatHelper } from '../utils/TableFormatHelper';

export default defineComponent({
    name: 'GenericListTable',

    components: {
        PaginatedTable
    },

    props: {
        // Data props
        pagination: {
            type: Object,
            required: true
        },
        currentPageData: {
            type: Array,
            required: true
        },
        headers: {
            type: Array,
            required: true
        },

        // Configuration props
        primaryKey: {
            type: String,
            required: true
        },
        actionHeaderValue: {
            type: String,
            required: true
        },
        quickSearchValue: {
            type: String,
            default: ''
        },
        loadingMessage: {
            type: String,
            default: 'Loading...'
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    emits: ['page-size-change', 'page-select', 'next-page', 'previous-page'],

    methods: {
        formatCellValue(item: any, header: { value: string; format?: string }) {
            if (header.value === this.actionHeaderValue) {
                return '';
            }
            return TableFormatHelper.formatDateTimeCellValue(item, header);
        },
        onPageSizeChange() {
            this.$emit('page-size-change');
        },
        onPageSelect(page: number) {
            this.$emit('page-select', page);
        },
        onNextPage() {
            this.$emit('next-page');
        },
        onPreviousPage() {
            this.$emit('previous-page');
        }
    }
});
</script>
